import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export default ({ children }) => {
  const auth = useSelector((state) => state.auth);
  const isAuthenticated = auth.token !== null;
  return isAuthenticated ? children : <Navigate to="/" />;
};
